import React from 'react'
import { connect } from 'react-redux'
import animations from './animations'
import NavItem from '../NavItem'
import Logo from '../../components/Logo'
import LoggedInAs from '../../components/LoggedInAs'

class NavDesktop extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            navItems: []
        }
    }

    componentDidMount () {
        this.setState({
            navItems: { ...this.props.items }
        })

        document.addEventListener('touchstart', this.handleSubNavParentTouchAway.bind(this))
        animations.animateOnScroll(this.container)
    }

    componentDidUpdate (prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                navItems: { ...this.props.items }
            })
        }
    }

    componentWillUnmount () {
        document.addEventListener('touchstart', this.handleSubNavParentTouchAway.bind(this))
    }

    handleSubNavParentTouchAway (event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            animations.closeAllSubNavs()
        }
    }

    render () {
        const NavItems = Object.keys(this.state.navItems).map(key => {
            const item = this.state.navItems[key]
            return (
                <NavItem
                    key={key}
                    title={item.title}
                    url={item.url}
                    children={item.children}
                    active={item.active}
                    handleMouseEnter={animations.handleSubNavMouseEnter}
                    handleMouseLeave={animations.handleSubNavMouseLeave}
                    handleParentTouch={animations.handleSubNavTouch}
                    closeAllSubNavs={animations.closeAllSubNavs}
                />
            )
        })

        return (
            <div className='nav-desktop' ref={el => this.container = el}>
                <div className='inner'>
                    <Logo />
                    <div className='nav'><ul ref={el => this.wrapperRef = el}>{NavItems}</ul></div>
                    <LoggedInAs firstName={this.props.firstName} lastName={this.props.lastName} />
                </div>
            </div>
        )
    };
}

const mapStateToProps = state => ({
    firstName: state.auth.firstName,
    lastName: state.auth.lastName
})

export default connect(mapStateToProps, {})(NavDesktop)



// WEBPACK FOOTER //
// ./resources/js/layout/NavDesktop/NavDesktop.js